/* unplugin-vue-components disabled */import { render } from "./kunshan.vue?vue&type=template&id=88225624&scoped=true"
import script from "./kunshan.vue?vue&type=script&lang=js"
export * from "./kunshan.vue?vue&type=script&lang=js"

import "./kunshan.vue?vue&type=style&index=0&id=88225624&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88225624"]])

export default __exports__